import { render, staticRenderFns } from "./AddressListing.vue?vue&type=template&id=88278db2&scoped=true&"
import script from "./AddressListing.vue?vue&type=script&lang=js&"
export * from "./AddressListing.vue?vue&type=script&lang=js&"
import style0 from "./AddressListing.vue?vue&type=style&index=0&id=88278db2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88278db2",
  null
  
)

export default component.exports